<!--suppress ALL -->

<template>
    <el-dialog top="10px" title="创建数字分身" :visible.sync="isImportVisible" width="400" :close-on-click-modal="false" :close-on-press-escape="false" :append-to-body="true" :fullscreen="false">

    <el-form autocomplete="off" ref="operationForm" label-position="top"
          style="margin-top: 30px; width: 95% ">


      <el-form-item prop="title" label="名称">
        <el-input v-model="title" size="large"
               clearable
               placeholder=""
               autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item prop="title" label="视频文件">
        <video-upload upload-text="点击上传视频 视频长度1-5分钟 mp4格式" @upload-success="fileUploadSuccess" :meta-data="true" :origin-file-require="false"></video-upload>
      </el-form-item>

    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button class="btn" size="large" @click="confirmImport">确定
      </el-button>
      <el-button @click="isImportVisible = false">关闭</el-button>
    </div>
    </el-dialog>


</template>


<script>
import VideoUpload from "@/components/VideoUpload"
export default {
  name: 'video_avatar_clone',
  data() {
    return {
      isImportVisible: false,
      video_url: null,
      fileNameView: '',
      title: '',
      video_cover:''

    }
  },
  components: {VideoUpload},
  methods: {

    show() {
      this.isImportVisible = true
    },

    fileUploadSuccess(e,name,data) {
      this.video_url = e;
      this.video_cover = data.videoCover
    },

    batchImport() {
      this.isImportVisible = true
    },
    confirmImport() {
      if (!this.video_url) {
        this.$Message.warning('请上传文件！')
        return
      }
      let t = this

      this.$post(
        {
          context: t,
          loading: true,
          path: '/aigc/video/avatar/create/',
          params: {"title": this.title, "video_url": this.video_url,"video_cover": this.video_cover},
          success: function (data) {
            t.isImportVisible = false
            t.$emit('refresh')
          },
          error: function () {
          }
        }
      )
    },
  }

}
</script>
